import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';
export default function addUserPageButton() {
  extend(UserPage.prototype, 'navItems', function (items) {
    const canUpload = !!app.forum.attribute('fof-upload.canUpload');
    const user = this.user;
    const hasUploads = !!(user != null && user.uploadCountCurrent());
    const sessionUser = app.session.user;
    if (!this.user || !sessionUser) return;
    if (sessionUser.viewOthersMediaLibrary() || this.user === sessionUser && (canUpload || hasUploads)) {
      var _user$uploadCountCurr;
      const uploadCount = (_user$uploadCountCurr = user == null ? void 0 : user.uploadCountCurrent()) != null ? _user$uploadCountCurr : 0;
      items.add('uploads', LinkButton.component({
        href: app.route('user.uploads', {
          username: this.user.slug()
        }),
        name: 'uploads',
        icon: 'fas fa-file-upload'
      }, [this.user === sessionUser ? app.translator.trans('fof-upload.forum.buttons.media') : app.translator.trans('fof-upload.forum.buttons.user_uploads'), ' ', uploadCount > 0 ? m("span", {
        className: "Button-badge"
      }, uploadCount) : null]), 80);
    }
  });
}